import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import axios from "../../helpers/axios";
import {
  GeneralTable,
  Layout,
  Notification,
  ScreenHeading,
} from "../../webtracking/components";

const useInvoiceScreen = () => {
  const { invoiceId } = useParams();
  const history = useHistory();

  const [invoice, setInvoice] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [selection, setSelection] = useState([]);
  const [message, setMessage] = useState("");

  const loadInvoice = (id) => {
    setLoading(true);
    axios
      .get(`/api/invoices/${id}/`)
      .then(({ data }) => setInvoice(data))
      .catch((error) => console.log(error))
      .then(() => setLoading(false));
  };

  useEffect(() => {
    loadInvoice(invoiceId);
  }, [invoiceId]);

  const handleCompleteInvoice = () => {
    let status;
    if (selection.length === invoice.parts.length) {
      status = "COMPLETED";
    } else {
      status = "PARTIAL";
    }

    axios
      .patch(`/api/invoices/${invoice.id}/`, {
        status: status,
        selection: selection.map((ix) => invoice.parts[ix].id),
      })
      .then(() => {
        history.push("/invoices");
      })
      .catch((error) => console.error(error))
      .then(() => {
        setMessage("No se pudo guardar, reintente más tarde");
      });
  };

  return {
    isLoading,
    handleCompleteInvoice,

    selection,
    setSelection,

    invoice,
    message,
  };
};

const InvoiceScreen = () => {
  const {
    isLoading,
    handleCompleteInvoice,

    selection,
    setSelection,

    invoice,
    message,
  } = useInvoiceScreen();

  if (isLoading) {
    return null;
  }

  const cols = [
    {
      label: "SOS",
      render: (row) => <span>{row.sos1}</span>,
    },
    {
      label: "Parte",
      render: (row) => <span>{row.pano20}</span>,
    },
    {
      label: "Cantidad",
      render: (row) => <span>{row.qty4}</span>,
    },
    {
      label: "Descripción",
      render: (row) => <span>{row.ds18}</span>,
    },
  ];

  const host = process.env.REACT_APP_BACKEND_HOST;

  return (
    <Layout>
      <ScreenHeading title={`Factura ${invoice.name}`} />
      <div className="container has-background-light p-6 mt-5">
        <Notification message={message} />
        <div className="card mb-5">
          <div
            className="level has-grey-text has-text-centered"
            style={{ lineHeight: "70px" }}
          >
            <div className="level-item">
              <div>
                <b>Factura</b>
                &nbsp; {invoice.name}
              </div>
            </div>
            <div className="level-item">
              <div>
                <b>Status</b>
                &nbsp; <div className="tag">{invoice.status}</div>
              </div>
            </div>
            <div className="level-item">
              <div>
                <b>Adjunto</b>
                &nbsp;
                <a
                  href={`${host}api/invoices/${invoice.id}/download/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Descargar
                </a>
              </div>
            </div>
            <div className="level-item">
              <div style={{ lineHeight: "1rem" }}>
                <button
                  className="button is-primary"
                  disabled={
                    !selection.length ||
                    selection.length === invoice.parts.length
                  }
                  onClick={handleCompleteInvoice}
                >
                  Factura Parcial
                </button>
              </div>
            </div>
            <div className="level-item">
              <div style={{ lineHeight: "1rem" }}>
                <button
                  className="button is-primary"
                  disabled={selection.length < invoice.parts.length}
                  onClick={handleCompleteInvoice}
                >
                  Factura Completada
                </button>
              </div>
            </div>
          </div>
        </div>
        <GeneralTable
          rowKey="id"
          isLoading={isLoading}
          rows={invoice.parts}
          cols={cols}
          hasSelection
          selection={selection}
          setSelection={setSelection}
        />
      </div>
    </Layout>
  );
};

export default InvoiceScreen;
